/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_IssuesInputs */

const en_mk_mx_issues = /** @type {(inputs: Mk_Mx_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active issues`)
};

const id_mk_mx_issues = /** @type {(inputs: Mk_Mx_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue aktif`)
};

/**
* | output |
* | --- |
* | "Active issues" |
*
* @param {Mk_Mx_IssuesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_issues = /** @type {((inputs?: Mk_Mx_IssuesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_IssuesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_issues(inputs)
	return en_mk_mx_issues(inputs)
});